import PropTypes from 'prop-types';
import React from 'react';
import OtherField from '../shared/OtherField';
import { connect } from 'react-redux';
import { questionKey } from '../response/reducer';

const ConditionalOtherField = ({
  add_other,
  name,
  otherSelected,
  questionId,
}) =>
  add_other && otherSelected ? (
    <OtherField name={name} type="text" questionId={questionId} />
  ) : null;

ConditionalOtherField.propTypes = {
  add_other: PropTypes.bool,
  name: PropTypes.string.isRequired,
  otherSelected: PropTypes.bool,
  questionId: PropTypes.string.isRequired,
};

ConditionalOtherField.defaultProps = {
  otherSelected: true,
};

const mapStateToProps = (state, ownProps) => {
  const question = state[questionKey(ownProps)];
  return {
    otherSelected:
      question.values.length === 1 && question.values[0] === 'other',
  };
};

const SelectListOther = connect(mapStateToProps)(ConditionalOtherField);

export default SelectListOther;
